import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { Trash2 } from 'lucide-react';
import { displayDate } from '../../lib/dates';

export const PayoutCardList = ({ payouts, fmt, onDelete }) => (
  <div className="md:hidden space-y-3" data-testid="payouts-mobile-list">
    {payouts.length === 0 ? (
      <Card className="bg-white border border-[#D1D1CD] rounded-lg">
        <CardContent className="p-6 text-center text-[#5C5C5C]">
          No payouts recorded yet
        </CardContent>
      </Card>
    ) : (
      payouts.map((payout) => (
        <Card
          key={payout.id}
          data-testid={`payout-card-${payout.id}`}
          className="bg-white border border-[#D1D1CD] rounded-lg shadow-sm"
        >
          <CardContent className="p-4">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0 flex-1">
                <p className="font-semibold text-[#1C1C1E] truncate">{payout.worker_name}</p>
                <p className="text-xs text-[#5C5C5C] mt-0.5">
                  {displayDate(payout.date)}
                </p>
              </div>
            </div>
            <p className="mt-2 text-2xl font-bold text-[#2E4632]" style={{ fontFamily: 'Manrope, sans-serif' }}>
              {fmt(payout.amount)}
            </p>
            {payout.notes && (
              <p className="mt-1.5 text-sm text-[#5C5C5C] line-clamp-2">{payout.notes}</p>
            )}
            <div className="mt-3 pt-3 border-t border-[#D1D1CD]/60 flex justify-end">
              <Button
                variant="ghost"
                size="sm"
                data-testid={`delete-payout-mobile-${payout.id}`}
                onClick={() => onDelete(payout.id)}
                className="h-9 text-[#BC4749] hover:bg-[#BC4749]/10"
              >
                <Trash2 className="w-4 h-4 mr-1.5" /> Delete
              </Button>
            </div>
          </CardContent>
        </Card>
      ))
    )}
  </div>
);
